import React, { useEffect } from 'react'
import { Formik, Form } from 'formik'
import { 
  Button, 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogTitle, 
  TextField, 
  Typography,
  Box,
  CircularProgress,
  Snackbar
} from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import * as yup from 'yup'
import { useNavigate } from 'react-router-dom';
import { deployAiAgent } from '../redux/slices/DeployAIAgent';
import { useDispatch, useSelector } from 'react-redux';
import { FORM_KEYS } from '../utills/constant';
function DeployAIBot({open, onClose}) {
  const {deployAgentLoading} = useSelector((state) => state.DeploySlice);
  const {slugName} = useSelector((state) => state.CreateAgentSlice);
  //create agent response handle
  const validation = yup.object().shape({
    fileName: yup.string().required('File Name is required')
  })
  
  const dispatch = useDispatch()
  const initialValue = {
    fileName:'',
  };

  const handleRunAIAgent =()=>{
    dispatch(deployAiAgent(slugName))
  }


  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx:{
          width:'50%',
          margin:'auto',
          borderRadius:'15px'
        }
      }}
    >
      <Box
      sx={{
        display:'flex',
        justifyContent:'flex-end',
        mt:'15px'
      }}
      >
        <Button
            onClick={onClose}
            color='black'
        >
          <CancelOutlinedIcon fontSize='small'/>
        </Button>
      </Box>
      <DialogTitle
        sx={{
          margin:0,
          fontWeight:'bold',
          fontSize:'16px'
        }}
      >
        DEPLOY YOUR AGENT
      </DialogTitle>
      <DialogContent>
        <Formik
        initialValues={initialValue}
        validationSchema={validation}
        >
        </Formik>
      </DialogContent>
      <DialogActions
      sx={{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'center',
        m:1
      }}
      >
        <Button
        variant='outlined'
        color='#828282'
        onClick={onClose}
        sx={{
          color:'#828282',
          borderRadius:'18px',
          width:'35%'
        }}
        >
          CANCEL
        </Button>
        <Button 
        onClick={()=>handleRunAIAgent()}
        variant='contained'
        sx={{
          borderRadius:'18px',
          width:'35%',
          backgroundColor:'#3B5CFF'
        }}
        >
        {deployAgentLoading ? (
        <CircularProgress size={24} sx={{ color: '#fff' }} />
      ) : (
        'DEPLOY'
      )}
        </Button>
      </DialogActions>

    </Dialog>
  )
}

export default DeployAIBot
